
import { StorySection } from "./StorySection";
import { VisionSection } from "./VisionSection";
import { CommitmentSection } from "./CommitmentSection";
import { HeroSection } from "./Hero";
import RevealOnScroll from "@/components/ui/RevelOnScroll";
import { SEO } from "@/components/common/SEO";

export default function Company() {
  return (
    <>
      <SEO
        title="About VaWeNa — Built by Real Estate Investors, for Real Estate Investors"
        description="VaWeNa was built by frustrated investors who experienced the same problems you face. Learn our story, vision, and commitment to helping you invest with intelligence."
        canonical="/company"
      />
      <div className="w-full min-h-screen dark:bg-vw-bg bg-[#f0f4ff]">
        <main>
          <HeroSection />

          <RevealOnScroll direction="up">
            <StorySection />
          </RevealOnScroll>

          <RevealOnScroll direction="up">
            <VisionSection />
          </RevealOnScroll>

          <RevealOnScroll direction="up">
            <CommitmentSection />
          </RevealOnScroll>
        </main>
      </div>
    </>
  );
}
